export var RoleList = [
    'Head Office',
    'License Partner',
    'Brokerage Manager',
    'Broker of Record',
    'Advisor',
    'Operations',
    'Marketing',
    'Technology',
    'Hospitality',
    'Advisor Attraction',
    'Listing Manager',
    'Listing Management',
    'Leads Manager',
    'Finance',
    'Special Olympics',
    'Transaction Manager',
    'Transaction Management',
    'Advisor Assistant',
    'Intern'
];
